// extracted by mini-css-extract-plugin
module.exports = {"ColorSecondary":"Typography_ColorSecondary__1KNpz","ColorLight":"Typography_ColorLight__3qV7E","ColorError":"Typography_ColorError__2CaZm"};